module.exports = "<app-header></app-header>\r\n<div class=\"page-container\">\r\n    <app-menu></app-menu>\r\n    <div class=\"page-content-wrapper\">\r\n\t\t<div class=\"page-content\">\r\n\t\t\t<div ui-view=\"mainContent\" class=\"fade-in-up\">\r\n<p>\r\n Hello admin, <a routerLink=\"/logout\">Logout</a>\r\n</p>\r\n      </div>\r\n\t\t</div>\r\n\t</div>\r\n  </div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/wamp64/www/duetz.repos/angular4/src/app/_components/dashboard/dashboard.component.html
// module id = ../../../../../src/app/_components/dashboard/dashboard.component.html
// module chunks = 1